(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("checkoutStep5Complete", {
        templateUrl: "app/checkout/checkoutStep5Complete.component.html",
        controller: ["authService", "checkoutService", "frameworkService", "learningPlanService", "orderResource", "ngIntroService", "$scope", "$state", "$translate", "$localStorage", "$rootScope", "$timeout", CheckoutStep5CompleteCtrl],
        controllerAs: "vm"
    });
    function CheckoutStep5CompleteCtrl(authService, checkoutService, frameworkService, learningPlanService, orderResource, ngIntroService, $scope, $state, $translate, $localStorage, $rootScope, $timeout) {
        var vm = this;
        vm.orderId = $state.params.orderId;
        vm.frameworkData = frameworkService.data;
        vm.loaded = false;
        vm.examAttemptPurchaseState = $localStorage.examAttemptPurchaseState;
        delete $localStorage.examAttemptPurchaseState;
        checkoutService.setStep(5);
        if ($state.params.orderId) {
            orderResource.completeCheckOut({ id: $state.params.orderId }, function (data) {
                //console.log(data);
                learningPlanService.data = {};
                delete $localStorage.storefrontCart3;
                $rootScope.$broadcast("updateShoppingCartCount");
                vm.order = data;
                vm.hasProductDiscount = vm.order.orderItems.some(function (item) { return item.productDiscountAmount > 0; });
                vm.loaded = true;
                if (vm.order.purchaseType === "Inventory" && !authService.authentication.hasInventory)
                    authService.authentication.hasInventory = true;
            });
        }
        else {
            $state.go("main.shoppingCart");
        }
        ////////////////////////////////////////////////
        vm.translateName = function (name, isCountry) {
            if (name) {
                if (isCountry)
                    return $translate.instant("common.country." + name.replace(/\s+/g, ""));
                return $translate.instant("common.stateProvince." + name.replace(/\s+/g, ""));
            }
            return "";
        };
        //function showIntro() {
        //	var step1Intro = $translate.instant("storefront.inventory.intro.step1");
        //	var thanks = $translate.instant("common.Thanks");
        //	$timeout(function () {
        //		$scope.IntroOptions = {
        //			steps: [
        //				{
        //					//element: document.querySelector("#menu.storefront"),
        //					intro: step1Intro
        //					//position: "right"
        //				}
        //			],
        //			showStepNumbers: false,
        //			showBullets: false,
        //			exitOnOverlayClick: true,
        //			exitOnEsc: true,
        //			doneLabel: thanks
        //		};
        //		ngIntroService.clear();
        //		ngIntroService.setOptions($scope.IntroOptions);
        //		ngIntroService.start();
        //	}, 5000);
        //}
    }
}());
